export default "__VITE_ASSET__Cwrgkl_V__"